module.exports = __webpack_public_path__ + "img/image-002.a0a5dcbf.png";